import { render, staticRenderFns } from "./dialogShowSub.vue?vue&type=template&id=52659211"
import script from "./dialogShowSub.vue?vue&type=script&lang=js"
export * from "./dialogShowSub.vue?vue&type=script&lang=js"
import style0 from "./dialogShowSub.vue?vue&type=style&index=0&id=52659211&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports